import { LazyPageLoading } from '@components/lazy-page-loading'
import { loadPaymentSubmissionPreviewPage } from '@pages/payment-submission-preview/payment-submission-preview-loader'
import { lazy, Suspense } from 'react'

const PaymentSubmissionPreview = lazy(() =>
  loadPaymentSubmissionPreviewPage().then((module) => ({
    default: module.PaymentSubmissionPreview,
  })),
)

export const PaymentSubmissionPreviewRoute = () => (
  <Suspense fallback={<LazyPageLoading />}>
    <PaymentSubmissionPreview />
  </Suspense>
)
